import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { szGetFightingRank } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "effectivenessNew",
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      tableData: []
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.paramsData.page = e;
      this.reqLoading = true;
      szGetFightingRank(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.status == 200) {
          _this.tableData = JSON.stringify(res.data) != '[]' ? res.data.data : [];
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    currentChaneg: function currentChaneg(e) {
      this.paramsData.page = e;
      this.searchClick();
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      szGetFightingRank(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: _this2.$t('roleId'),
            prop: 'role_id'
          }, {
            label: _this2.$t('combatPower'),
            prop: 'fighting'
          }, {
            label: _this2.$t('level'),
            prop: 'level'
          }, {
            label: _this2.$t('lastLoginTime'),
            prop: 'last_login_time'
          }];

          _this2.$export.excel({
            columns: columns,
            data: res.data,
            title: _this2.$route.meta.title
          });
        }
      });
    }
  }
};